const issuerUrl = 'https://sweb.wuestenrot.at/auth/realms/wuero';
const logoutUrl = 'https://sweb.wuestenrot.at/auth/realms/wuero/protocol/openid-connect/logout';
const originUrl = window.location.origin;

export const authConfigDevelopment = {
  clientId: 'spa',
  issuer: 'https://idsvr4.azurewebsites.net',
  oidc: true,
  redirectUri: window.location.origin,
  responseType: 'code',
  scope: 'openid profile email offline_access',
  showDebugInformation: true,
  silentRefreshRedirectUri: window.location.origin
};

export const authConfigProduction = {
  logoutUrl,
  clientId: 'pis',
  issuer: issuerUrl,
  oidc: true,
  redirectUri: originUrl,
  responseType: 'code',
  scope: 'openid profile email offline_access',
  showDebugInformation: false,
  silentRefreshRedirectUri: originUrl
};
